import { writable } from "svelte/store";
import type { Writable } from "svelte/store";

interface HotkeysState {
  value: string;
  open: boolean;
}

const initialState: HotkeysState = {
  value: "",
  open: false,
};

const { subscribe, update, set }: Writable<HotkeysState> = writable(initialState);

export const hotkeysStore = {
  subscribe,

  setValue(value: string) {
    update((state) => ({
      ...state,
      value,
    }));
  },

  getValue() {
    return initialState.value;
  },

  setOpen(open: boolean) {
    update((state) => ({
      ...state,
      open,
    }));
  },

  getOpen() {
    return initialState.open;
  },

  toggleOpen() {
    update((state) => ({
      ...state,
      open: !state.open,
    }));
  },

  reset() {
    set(initialState);
  },
};
